import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getFeeds, feedSelector } from '../feature';

const useGetFeeds = () => {
  const dispatch = useAppDispatch();
  const { isLoading, error, feedsList, query } = useAppState(feedSelector);

  useEffect(() => {
    dispatch(
      getFeeds({
        page: 1,
      }),
    );
  }, []);

  return useMemo(
    () => ({
      feeds: feedsList?.data,
      pagination: feedsList?.meta,
      query,
      isLoading,
      error,
    }),
    [feedsList, isLoading, error, query],
  );
};

export default useGetFeeds;
